import { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { WebAppDevelopmentData } from "../../common";
// core components
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import { getIPGeoLocation } from "../../common/GeneralUtils";
// import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import * as Icons from '../../common/icons/webAppDevelopmentDataIcons';
import Toasts from "../../components/Toasts/Toasts";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )
// const TechIndustryQuality = Loadable(
//     lazy(() => import('../../components/TechIndustryQuality/TechIndustryQuality'))
// )

const AIAndMachineLearningServicesScreen = () => {
    const [toasts, setToasts] = useState(null)
    const [WebAppDevelopmentData, setData] = useState({});

    const getAllAIAndMachineLearningServicesData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/AIAndMachineLearningServices.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        getIPGeoLocation();
        getAllAIAndMachineLearningServicesData();
    }, [])
    return (
        <Fragment>
            <Helmet>
                <title>AI & Machine Learning Services | Intelligent Automation Solutions | VarahiSoft</title>
                <meta name="description" content="Discover how VarahiSoft’s AI & Machine Learning services help businesses streamline operations, automate smarter, and make data-driven decisions. Build intelligent systems that accelerate growth and profitability." />
                <meta name="keywords" content="AI & Machine Learning Services | Intelligent Automation Solutions" />
                <meta property="og:title" content="AI & Machine Learning Services | Intelligent Automation Solutions | VarahiSoft" />
            </Helmet>
            <div id="main-wrapper">
                <Header />
                <div className="page-wrapper web-app-development-page-wrapper">
                    <div className="container-fluid">
                        <div className="page-content-top">
                            <AboutUsBanner bannerImg={WebAppDevelopmentData?.bannerImg} data={WebAppDevelopmentData?.headerData} />
                            <section className="why-mobile-app-development bg-white pb-0">
                                <Container>
                                    <Row>
                                        <Col lg={12} md={12} sm={12}>
                                            <h2 className="pb-5 fw-bold">{WebAppDevelopmentData?.BuildFuture?.title}</h2>
                                        </Col>
                                        <Col className="tech-page-warper pe-5" lg={5} md={5}>
                                            {WebAppDevelopmentData?.BuildFuture?.textData.map((text, index) => <p className="pe-4" key={index}><span>{text?.text}</span> <span className="fw-bold">{text?.bold1}</span> <span>{text?.text1}</span> <span className="fw-bold">{text?.bold2}</span> <span>{text?.text2}</span></p>)}
                                        </Col>
                                        <Col lg={7} md={7} className="m-auto text-start">
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    src={WebAppDevelopmentData?.BuildFuture?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                            {/* <img src={tech?.pageImg} alt="img" /> */}
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="core-mobile-app-section">
                                <Container>
                                    <h3 className="text-center fs-2">{WebAppDevelopmentData?.CoreServices?.title}</h3>
                                    <h4>{WebAppDevelopmentData?.CoreServices?.subtitle}</h4>
                                    <div className="core-mobile-app-card">
                                        <Row className="m-0">
                                            {WebAppDevelopmentData?.CoreServices?.listData?.map((cardItem, index) => {
                                                const Icon = Icons[cardItem?.icon] || null;
                                                return <Col key={index} md={4} lg={4} sm={1}>
                                                    <Card className="app-card">
                                                        <CardBody>
                                                            <p className="mb-0">
                                                                {Icon && <Icon />}
                                                            </p>
                                                            <h5 className="card-title-div">{cardItem?.title}</h5>
                                                            <p className="mb-0"><span>{cardItem?.text}</span>{cardItem?.bold && <span>{cardItem?.bold}</span>}{cardItem?.text1 && <span>{cardItem?.text1}</span>}</p>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            })}
                                        </Row>

                                    </div>
                                </Container>
                            </section>
                            <section className="core-mobile-app-process" >
                                <Container>
                                    <h3>{WebAppDevelopmentData?.WhyChooseVarahiSoftforECommerceDevelopment?.title}</h3>
                                    <h4>{WebAppDevelopmentData?.WhyChooseVarahiSoftforECommerceDevelopment?.subTitle}</h4>
                                    <div className="core-mobile-app-card pt-5">
                                        <Row>
                                            <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                                                <div className="img-div-width">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        src={WebAppDevelopmentData?.WhyChooseVarahiSoftforECommerceDevelopment?.pageImg} // use normal <img> attributes as props
                                                    />
                                                </div>
                                            </Col>
                                            <Col className="content-body" lg={6} md={6} xs={12}>
                                                {WebAppDevelopmentData?.WhyChooseVarahiSoftforECommerceDevelopment?.listData?.map((chooseData, index) => {
                                                    const ChooseDataIcon = Icons[chooseData?.icon] || null;
                                                    console.log('------ChooseDataIcon-------', chooseData?.icon)
                                                    return (
                                                        <div key={index} className="px-5 d-flex align-items-start justify-content-start gap-3">
                                                            <div className="why-choose-icon">{ChooseDataIcon && <ChooseDataIcon />}</div>
                                                            <div className="why-cho0se-body">
                                                                <h5>
                                                                    {chooseData?.title}
                                                                </h5>
                                                                <p>{chooseData?.text}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className='core-mobile-app-build-somethingAmazingTogether-div' style={{ backgroundImage: `url(${WebAppDevelopmentData?.BuildSomethingAmazingTogether?.bgImg})` }}>
                                <div className="client-count text-white">
                                    <Container>
                                        <Row className='Fre8-Pro'>
                                            <Col lg="8" md='7' className='ps-0 m-auto d-flex justify-content-center align-items-center gap-5'>
                                                <div className="display-7 align-self-center">
                                                    <h3 className='mb-3'>{WebAppDevelopmentData?.BuildSomethingAmazingTogether?.title}</h3>
                                                    <p>{WebAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.text}<Link className='text-decoration-none text-white' to={window?.location?.origin}>{WebAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.link}</Link> {WebAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.text1}</p>
                                                    <div className="m-auto text-center">
                                                        <Link to={WebAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.link} className="btn btn-md my-get-btn m-t-30 font-14 rounded-5">
                                                            {WebAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.btnName} <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M9.39556 0.987879C9.63213 0.75404 10.0156 0.75404 10.2522 0.987879L15.906 6.57654C16.0197 6.6888 16.0835 6.84113 16.0835 6.99993C16.0835 7.15873 16.0197 7.31106 15.906 7.42339L10.2522 13.0121C10.0156 13.246 9.63213 13.246 9.39556 13.0121C9.15899 12.7783 9.15899 12.3991 9.39556 12.1653L14.0152 7.59872H0.939265C0.604711 7.59872 0.333496 7.33062 0.333496 6.99993C0.333496 6.66924 0.604711 6.40114 0.939265 6.40114H14.0152L9.39556 1.8347C9.15899 1.60086 9.15899 1.22173 9.39556 0.987879Z" fill="#0095DA" />
                                                            </svg>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </section>
                            <section className="choose-varahi-Soft">
                                <Container>
                                    <Row>
                                        <Col className="tech-page-warper px-5" lg={6} md={6}>
                                            <h3 className="pe-3">{WebAppDevelopmentData?.ChooseVarahiSoft?.title}</h3>
                                            <p>{WebAppDevelopmentData?.ChooseVarahiSoft?.paragraph}</p>
                                            <p>{WebAppDevelopmentData?.ChooseVarahiSoft?.paragraph1}</p>
                                        </Col>
                                        <Col lg={6} md={6} className="m-auto text-start">
                                            <div className="img-div-width m-auto">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    src={WebAppDevelopmentData?.ChooseVarahiSoft?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                            {/* <img src={tech?.pageImg} alt="img" /> */}
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className='Tech-Industry-Quality'>
                                <div className='tech-content py-4' style={{ backgroundImage: `url(${WebAppDevelopmentData?.TurningIdeas?.bgImg})` }}>
                                    <div className="bg-color-rgba">
                                        <Container className="py-4 ps-5">
                                            <Row className="justify-content-end">
                                                <Col lg="7" md="7" className="align-self-start">
                                                    <div className='page-content pb-5'>
                                                        <h3>{WebAppDevelopmentData?.TurningIdeas?.title}</h3>
                                                        {WebAppDevelopmentData?.TurningIdeas?.paragraph?.map((para, index) => {
                                                            return (
                                                                <p key={index}>{para?.text}<Link className='text-decoration-none text-white' to={window?.location?.origin}>{para?.link}</Link> {para?.text1}</p>
                                                            )
                                                        })}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </section>
                            <CustomerReviews />
                            <div className="home-contact-page">
                                <ContactUsComponent setToasts={setToasts} />
                            </div>
                            <FrequentlyAskedQuestions faqData={WebAppDevelopmentData?.FrequentlyAskedQuestionsData} />
                        </div>
                    </div>
                </div>
                <Footer />
                {toasts && <Toasts toastsList={toasts} />}
            </div>
        </Fragment>
    );
}

AIAndMachineLearningServicesScreen.propTypes = {
    classes: PropTypes.object
};

export default AIAndMachineLearningServicesScreen;
